var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('ModalComponent',{attrs:{"name":_vm.name,"title":_vm.title},on:{"close":() => _vm.close(false)}},[_c('Form',{attrs:{"data":_vm.grupo},on:{"terminado":function($event){return _vm.editar()}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }